import React, { Component, Fragment } from 'react';
import PropTypes from "prop-types";
import moment from 'moment';
import NotificationSystem from 'react-notification-system';
import { BeatLoader } from 'react-spinners';
import ReactTooltip from 'react-tooltip'
import { _addNotification, _addNotificationError, showFile, groupBy, getSchoolGrades } from '../../../server/util';
import { get, postWithHeaders, patch, post } from "../../../server/actions";
import ReactTable from 'react-table';
import '../../../../src/assets/css/react-table.css';
import _ from 'lodash';
import SchoolMealProgramView from './schoolMealProgramView'
import { schoolLunchAppPrint, printBlobFile, buildApplication } from './schoolLunchAppForPrint'
import TmExportExcel from '../../Misc/tmExportExcel/tmExportExcel'
import ReactExport from "react-data-export";
import { date_format } from '../../../server/constants';
import print from 'print-js';
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';
import checkboxHOC from "react-table/lib/hoc/selectTable";
import Modal from 'react-modal';
import RichText from '../../Misc/RichText';
import { EditorState, convertToRaw } from 'draft-js';
import draftToHtml from 'draftjs-to-html';
import EditLog from './EditLog';
import { getManageSchoolSettingList, getActiveSchoolYearSettings } from '../ManageSchools/manageSchoolSettings';

const CheckboxTable = checkboxHOC(ReactTable);
let gradeList = [];

const modalStyles = {
    content:
    {
        top: '5%',
        left: '50%',
        right: 'auto',
        bottom: '10%',  // Allow space at the bottom
        marginRight: '-50%',
        transform: 'translate(-50%, 0)',
        maxHeight: '80vh', // For vertical scroll if needed
        overflowY: 'auto',
        width: '60%'
    }
};

var converter = require('number-to-words');
const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;
class SchoolLunchProgramList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            schoolYearSettings: {},
            applications: [],
            applicationsExport: [],
            columns: [],
            eligibleSummaryData: [],
            summaryDataExport: [],
            search: {
                searchText: '',
                searchStatus: 'All'
            },
            newAppModal: false,
            selectedFile: undefined,
            tempStatusEligible: false,
            statusList: [],
            catagoryList: [],
            newFilterData: [],
            categoryFilterData: [],
            modalIsOpen: false,
            schools: [],
            selectedSchool: '',
            subject: '',
            message: '',
            htmlText: '',
            parentEmail: '',
            studentsData: [],
            searchStd: {
                searchText: '',
                searchStatus: 'All'
            },
            filterStudentsData: [],
            selectAll: false,
            selection: [],
            selectionStuList: {},
            tabIndex: 'All',
            reqObj: {
                schoolName: "",
                subject: "",
                message: EditorState.createEmpty(),
                htmlText: '',
                footer: "",
                attachments: [],
            },
            loggedUser: JSON.parse(sessionStorage.getItem('loggedInUserInfo')),
            editLogModalIsOpen: false,
            editLogs: []
        }
        this.getAllApplications = this.getAllApplications.bind(this);
        this.getColumns = this.getColumns.bind(this);
    }

    componentWillMount = () => {
         this.setState({ columns: this.getColumns() });
         this.getSchoolYearSettings();
        let schoolId = sessionStorage.getItem('SchoolId');
               if(sessionStorage.getItem('ROLE')==='ROLE_SUPERADMIN'){
                schoolId=this.props.school._links.self.href.split('/').pop();
                this.setState({schoolName:'['+this.props.school.schoolName+']'})
            }
            else{
                schoolId=sessionStorage.getItem('SchoolId');
            }
                this.setState({ loading: true })
                get('/mealSchools/' + schoolId + '/school?access_token=').then((response) => {
                    if (!response.ok) {
                        throw Error(response.statusText);
                    }
                    console.log('response', response);
                    return response.json();
                }).then(data => {
                    let _userInfo = JSON.parse(sessionStorage.getItem('loggedInUserInfo'))
                    _userInfo.mobileNo = (_userInfo.mobileNo || '').substr(-this.state.mobileLength);
                    this.setState({
                        schoolInfo: data,
                        loading: false,
                        userInfo: _userInfo
                    }, () => {
                        console.log(this.state.userInfo)
                    });
        
                })
                    .catch(
                        (error) => {
                            this.setState({
                                loading: false
                            })
                            console.log('Get Meal Menu response', error)
                        }
                    )
                this.setState({ loading: true })
                get('/mealSchools/' + schoolId + '?access_token=').then((response) => {
                    if (!response.ok) {
                        throw Error(response.statusText);
                    }
                    console.log('response', response);
                    return response.json();
                }).then(data => {
                    let _dataObj = data
                    _dataObj.contactPPhone = (_dataObj.contactPPhone || '').substr(-this.state.mobileLength);
                    _dataObj.principalPhone = (_dataObj.principalPhone || '').substr(-this.state.mobileLength);
                    if(_dataObj.contactPEmail !== "" && _dataObj.contactPName !== "" && _dataObj.contactPPhone !== ""){
                        this.setState({
                            schoolLogo: data.logoLink,
                            loading: false,
                            mealSchoolInfo: _dataObj
                        }, () => {
                    })
                  }
                  else{
                    this.getManageSchools().then(manageSchools => {
                    const mealSchoolInfo = {..._dataObj, ...manageSchools};
                    this.setState({
                        schoolLogo: data.logoLink,
                        loading: false,
                        mealSchoolInfo: mealSchoolInfo
                        }, () => {
                    })
                 })
                }
                })
                    .catch(
                        (error) => {
                            this.setState({ loading: false })
                            //console.log('Get school logo response', error)
                        }
                    )
            }
    componentDidMount = () => {
        this._notificationSystem = this.refs.notificationSystem;
        this.getAllApplications()
        this.getEligibilitySummary()
        this.getNotSubmittedFRMappData()
    }
    getEditLogs = (applicationId) => {
        get(`/householdapplicationEditLogs/${applicationId}?access_token=`)
            .then((response) => {
                if (!response.ok) {
                    throw Error(response.statusText);
                }
                return response.json();
            }).then(data => {
                this.setState({ editLogs: data, editLogModalIsOpen: true });
            }).catch(error => {
                console.log("Error fetching edit logs:", error);
            });
    }
    
    getSchoolYearSettings = () => {
        getActiveSchoolYearSettings(sessionStorage.getItem('SchoolId'))
            .then((schoolYearSettings) => {
                this.setState({ schoolYearSettings });
            }).catch(
                (error) => {
                    console.log('Get manage school response', error)
                }
            );
    }

     getManageSchools = () => {
                    return getManageSchoolSettingList(sessionStorage.getItem('SchoolId')).then((response) => {
                        if (!response.ok) {
                            throw Error(response.statusText);
                        }
                        return response.json();
                    }).then(data => {
                       const schoolListData = ((data._embedded || {}).schoolYears || []).find(col => {
                        const now = new Date();
                        const sd = new Date(col.sessionStartDateTime);
                        const ed = new Date(col.sessionEndDateTime);
    
                        return sd <= now && now <= ed;
                        });
                        if (!schoolListData) {
                        // return an object with explicit NO DATA markers so caller can handle it
                        return {
                           contactPName: 'NO data found',
                           contactPEmail: 'NO data found',
                           contactPPhone: 'NO data found',
                           benefitsPersonName: null,
                           benefitsPersonEmail: null,
                           benefitsPersonPhone: null
                        };
                    }
                    const { sessionStartDateTime, sessionEndDateTime } = schoolListData;
                    // Normalize contact fields and use explicit NO data marker when missing
                    schoolListData.contactPEmail = schoolListData.benefitsPersonEmail || 'NO data found';
                    schoolListData.contactPName = schoolListData.benefitsPersonName || 'NO data found';
                    schoolListData.contactPPhone = schoolListData.benefitsPersonPhone || 'NO data found';
                    return schoolListData; 
                    }).catch(error => {
                        console.log('Error fetching manage schools list:', error);
                    });
                }
    getEligibilitySummary = (isExport = false) => {
        let schoolId = sessionStorage.getItem('SchoolId');
        const currentDate = moment().format("YYYY-MM-DD")
        const url = `/reports/eligibilitySummary?districtId=${schoolId}&isSchoolId=true&currentDate=${currentDate}&isExport=${isExport}&access_token=`
        get(url).then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            console.log('response', response);
            this.setState({ loading: false });
            if (isExport) {
                return response.blob()
            } else {
                return response.json()
            }

        }).then(data => {
            if (isExport) {

                let filename = "Eligibility Summary Reports for ";

                showFile(data, filename);
            } else {
                console.log(data.response)
                this.setState({
                    eligibleSummaryData: data.response, summaryDataExport: data.response,
                    tempStatusEligible: (data.response || {}).tempStatusEligible
                });
            }

        }).catch(error => {
            this.setState({ loading: false });
            console.log("Download Failed", error)
        })
    }
    getColumns = () => {
        let columns = [];
        columns.push({
            accessor: 'applicationId',
            id: "applicationId",
            Header: 'App. ID',
            sortable: true,
            Cell: (props) => (("00000" + props.value).slice(-5)),
            style: { textAlign: 'center' },
            width: 100
        });
        columns.push({
            accessor: 'date',
            Header: 'APPLIED ON',
            Cell: (props) => (moment(props.value, 'MMDDYYYY').format(date_format())),
            style: { textAlign: 'center' },
            width: 100
        });
       columns.push({
            Header: 'Parent Email Id',
            id: 'parentEmail',
            Cell: (props) => {
                    const adult = props.original.householdAppInfo.find(
                    item => item.personType === 'Adult' && item.filledTheApplication === true
                );
                return (
                    <span>
                        {adult && adult.contact ? adult.contact.email : ''}
                    </span>
                );
                },
                style: { textAlign: 'center' }
       });
        columns.push({
            accessor: 'eligibility',
            Header: 'ELIGIBILITY',
            style: { textAlign: 'center' },
            Cell: ({ row }) => {
                let obj = (row._original.eligibility || []).length > 0 ? (row._original.eligibility || [])[0] : {};
                let status = obj[Object.keys(obj)[0]] || '';

                return (
                    status


                    /*  <div style={{textAlign:"left"}}>
                         <ul>
                         {
                             (row._original.eligibility).map(stu=>{                                
                                 return <li><span style={{fontSize:'10px', fontWeight:'bold'}}>{Object.keys(stu)[0]}: </span><span style={{fontSize:'10px', fontWeight:'italic'}}>{stu[Object.keys(stu)[0]]}</span></li>
                             })
                         }
                         </ul>
                     </div> */
                )
            }
        });
        columns.push({
            accessor: "applicationUrl",
            Header: 'File',
            style: { textAlign: 'center' },
            width: 100,
            Cell: ({ row }) => (row._original.applicationUrl && <div >
                <a title={row._original.applicationUrl} href={row._original.applicationUrl}
                    target='_blank'
                    className="fa fa-file-image-o fa-2x"><i /></a>
            </div>)

        })
        columns.push({
            id: 'status',
            accessor: "status",
            Header: 'APP. STATUS',
            style: { textAlign: 'center' }, // className: "actions text-center"
            width: 100,
            Cell: ({ row }) => (
                <div style={{ textAlign: "center" }}>
                    {
                        row._original.status === 'declined' ?
                            <span><i className="fa fa-circle color-3"></i> Verified</span> :
                            row._original.status === 'in-complete' ?
                                <Fragment>
                                    <i className="fa fa-circle color-1"></i> <a className="btn-linkedin-link" style={{ padding: '0px', cursor: 'pointer' }}
                                        data-tip data-for={'rtd-' + row._original.applicationId}>
                                        {'In-complete'}</a>
                                    <ReactTooltip multiline={true} id={'rtd-' + row._original.applicationId} aria-haspopup='true' type="dark" effect="float">
                                        <div>
                                            <ul style={{ textAlign: 'left' }}>
                                                {(row._original.incompleteReasonList || []).map((item, i) => {
                                                    if (item.isApplicable) {
                                                        return <li>{item.name === 'Other:' ? item.description : item.name
                                                        }</li>
                                                    }

                                                })}
                                            </ul>

                                        </div>
                                    </ReactTooltip>
                                </Fragment> :
                                row._original.status === 'approved' ?
                                    <span><i className="fa fa-circle color-2"></i> Verified</span> :
                                    row._original.status === 'cancelled' ?
                                        <Fragment>
                                            <i className="fa fa-circle color-3"></i> <a className="btn-linkedin-link" style={{ padding: '0px', cursor: 'pointer' }}
                                                data-tip data-for={'rtd-' + row._original.applicationId}>
                                                {'Cancelled'}</a>
                                            <ReactTooltip multiline={true} id={'rtd-' + row._original.applicationId} aria-haspopup='true' type="dark" effect="float">
                                                <div>
                                                    {row._original.cancelledNote}

                                                </div>
                                            </ReactTooltip>
                                        </Fragment> :
                                        row._original.status === 'denied' ?
                                            <span><i className="fa fa-circle color-3"></i> Denied</span> :
                                            <span><i className="fa fa-circle color-4"></i> Pending</span>
                    }
                </div>
            ),
        });
        columns.push({
            Header: 'UPDATED ON',
            accessor: 'statusUpdateDate',
            Cell: (props) => (props.value ? moment(new Date(props.value)).format(date_format()) : ''),
            style: { textAlign: 'center' },
            width: 100
        })
        return columns;
    }
    getAllApplications = () => {
        this.setState({ loading: true });
        let schoolId = sessionStorage.getItem('SchoolId');
        get('/getHouseholdApp?mealSchoolId=' + schoolId + '&schoolYear=' + sessionStorage.getItem('schoolYearValue') + '&access_token=')
            .then((response) => {
                if (!response.ok) {
                    throw Error(response.statusText);
                }
                return response.json();
            }).then(data => {
                let approved = 0;
                let pending = 0;
                let pendingConfirm = 0;
                let Incomplete = 0;
                let denied = 0;
                let cancelled = 0;
                const resData = data.sort((a, b) => { return b.applicationId - a.applicationId }).map(item => {
                    if (!item.prmyParentEmail) {
                        item.prmyParentEmail = (((item.householdAppInfo || [])[0] || {}).contact || {}).email
                    }
                    if (item.status === 'approved' || item.status === 'declined' || item.status === 'denied') {
                        const kidsList = []
                        item.householdAppInfo.filter(s => s.personType === "Student").map((kid) => {
                            const rec = {};
                            rec[kid.lname + ', ' + kid.fname] = (kid.isFreeMeal ? 'Free' : (kid.isFreeMeal === false ? 'Reduced' : 'Regular'));
                            kidsList.push(rec);
                        })
                        item.eligibility = kidsList;
                    } else {
                        item.eligibility = [];
                    }
                    if (item.status === 'approved') {
                        approved++;
                    } else if (item.status === 'pending') {
                        pending++;
                    } else if (item.status === 'pending-confirm') {
                        pendingConfirm++;
                    } else if (item.status === 'in-complete') {
                        Incomplete++;
                    } else if (item.status === 'denied') {
                        denied++;
                    } else if (item.status === 'cancelled') {
                        cancelled++;
                    }
                    return item;
                });
                const statusList = [
                    { status: "Approved", total: approved },
                    { status: "Pending", total: (pending + pendingConfirm) },
                    { status: "In-complete", total: Incomplete },
                    { status: "Denied", total: denied },
                    { status: "Cancelled", total: cancelled },
                    { status: "Total", total: approved + pending + pendingConfirm + Incomplete + denied + cancelled },
                ];
                this.getByCategoryOnClickOfStatusAnchorTags(resData);
                const statusListWithAnchors = statusList.map(item => ({
                    ...item,
                    total: <a href="#" onClick={() => this.handleStatusAnchorClick(item.status, item.total)}>{item.total}</a>,
                }));
                // this.setState({ applications: data.sort((a, b) => { return b.applicationId - a.applicationId }), loading: false }, () => {
                //     this.setState({ applicationsExport: this.filterData() })
                // });
                this.setState({
                    applications: resData,
                    statusList: statusListWithAnchors,
                    newFilterData: resData,
                    categoryFilterData: resData,
                    loading: false,
                    applicationsExport: resData
                });
            }).catch(
                (error) => {
                    this.setState({ loading: false })
                    console.log('Get School data response', error)
                }
            );
    }
    filterData = () => {
        const { search, applications } = this.state;
        const appStatus = {
            'declined': 'Verified',
            'in-complete': 'In-complete',
            'approved': 'Verified',
            'pending': 'Pending',
            'cancelled': 'Cancelled',
            'denied': 'Denied'
        };
        if (search.searchText === '' && (search.searchStatus === 'All' || search.searchStatus === '')) {
            this.setState({ newFilterData: applications, categoryFilterData: applications, applicationsExport: applications }, () => {
                this.getByCategoryOnClickOfStatusAnchorTags(this.state.newFilterData);
            });
            return;
        }

        const filteredData = (applications || []).filter(app => {
            const appid = ("00000" + app.applicationId).slice(-5);
            return (
                (search.searchText === '' || appid.includes(search.searchText) || (app.prmyParentEmail || '').includes(search.searchText)) &&
                (search.searchStatus === 'All' || appStatus[app.status] === search.searchStatus)
            );
        });
        this.setState({ newFilterData: filteredData, categoryFilterData: filteredData, applicationsExport: filteredData }, () => {
            this.getByCategoryOnClickOfStatusAnchorTags(this.state.newFilterData);
        });
    };

    handleStatusAnchorClick = (status, total) => {
        console.log(`Status: ${status}, Total: ${total}`);
        let searchStatus = status === 'Total' ? 'All' : (status === 'Approved' ? 'Verified' : status);
        this.setState(prevState => ({
            search: { ...prevState.search, searchStatus }
        }), () => {
            this.filterData();
        });
    };

    handleCategoryAnchorClick = (category, item) => {
        const { categoryFilterData } = this.state;
        const categories = {
            'Income': ["FederalIncome", "StateIncome", ""],
            'Case Based': ["TANF", "SNAP", "FDPIR"],
            'Other Categorical': ["Foster", "Homeless", "Migrant", "Runaway", "HeadStart"]
        };
        const eligibility = categories[category] || [];

        const filteredData = (categoryFilterData || []).filter(app => {
            if (!eligibility.includes(app.eligibilityDeterminedByProgam)) {
                return false;
            }
            const firstStudent = app.householdAppInfo.find(kid => kid.personType === "Student");
            if (!firstStudent) {
                return false;
            }
            switch (item) {
                case "free":
                    return firstStudent.isFreeMeal === true;
                case "reduced":
                    return firstStudent.isFreeMeal === false;
                case "errorProne":
                    return app.errorProne;
                case "regular":
                    return firstStudent.isFreeMeal === null;
                default:
                    return true;
            }
        });

        this.setState({
            newFilterData: filteredData
        });
    };


    getByCategoryOnClickOfStatusAnchorTags = (data) => {
        const categories = ["Income", "Case Based", "Other Categorical"];
        let catList = [];

        categories.forEach(category => {
            catList.push({
                category: category,
                free: 0,
                reduced: 0,
                errorProne: 0,
                regular: 0
            });
        });

        data.forEach(item => {
            let catObj = {};
            if (["FederalIncome", "StateIncome", ""].includes(item.eligibilityDeterminedByProgam)) {
                catObj.category = "Income";
            } else if (["TANF", "SNAP", "FDPIR"].includes(item.eligibilityDeterminedByProgam)) {
                catObj.category = "Case Based";
            } else if (["Foster", "Homeless", "Migrant", "Runaway", "HeadStart"].includes(item.eligibilityDeterminedByProgam)) {
                catObj.category = "Other Categorical";
            }

            const firstStudent = item.householdAppInfo.find(s => s.personType === "Student");
            if (firstStudent) {
                if (firstStudent.isFreeMeal === true) {
                    catObj.free = 1;
                } else if (firstStudent.isFreeMeal === false) {
                    catObj.reduced = 1;
                } else {
                    catObj.regular = 1;
                }
            }

            catObj.errorProne = item.errorProne ? 1 : 0;

            const existingCat = catList.find(c => c.category === catObj.category);
            if (existingCat) {
                existingCat.free += catObj.free || 0;
                existingCat.reduced += catObj.reduced || 0;
                existingCat.errorProne += catObj.errorProne || 0;
                existingCat.regular += catObj.regular || 0;
            } else {
                catList.push({
                    category: catObj.category,
                    free: catObj.free || 0,
                    reduced: catObj.reduced || 0,
                    errorProne: catObj.errorProne || 0,
                    regular: catObj.regular || 0
                });
            }
        });

        const categoryListWithAnchors = catList.map(item => ({
            ...item,
            free: <a href="#" onClick={() => this.handleCategoryAnchorClick(item.category, "free")}>{item.free}</a>,
            reduced: <a href="#" onClick={() => this.handleCategoryAnchorClick(item.category, "reduced")}>{item.reduced}</a>,
            errorProne: <a href="#" onClick={() => this.handleCategoryAnchorClick(item.category, "errorProne")}>{item.errorProne}</a>,
            regular: <a href="#" onClick={() => this.handleCategoryAnchorClick(item.category, "regular")}>{item.regular}</a>
        }));

        this.setState({
            catagoryList: categoryListWithAnchors
        });
    }

    getEligibilitySummaryColumns = () => {
        const { tempStatusEligible } = this.state;
        let cols = [
            {
                Header: "Site",
                filterable: false,
                sortable: false,
                accessor: "schoolName",
                style: { textAlign: 'left', whiteSpace: "pre-line" },
                show: false,
                Cell: row => (
                    <span style={{ textAlign: 'left' }}>{row.original.schoolName}</span>
                )
            }];
        cols = [...cols, ...[
            {
                Header: "Total Free",
                accessor: "totalFree",
                style: { textAlign: 'right', whiteSpace: "pre-line" },
                filterable: false,
                Cell: row => (<p>{(row.original.totalFree)}</p>)

            },
            {
                Header: "Total Reduced",
                accessor: "totalRed",
                style: { textAlign: 'right', whiteSpace: "pre-line" },
                filterable: false,
                Cell: row => (<p> {(row.original.totalRed)}</p>)
            },
            {
                Header: "Total Paid",
                accessor: "totalPaid",
                style: { textAlign: 'right', whiteSpace: "pre-line" },
                filterable: false,
                Cell: row => (<p> {(row.original.totalPaid)}</p>)
            },
            {
                Header: "Total Inactive",
                accessor: "totalInactive",
                style: { textAlign: 'right', whiteSpace: "pre-line" },
                filterable: false,
                Cell: row => (<p> {(row.original.totalInactive)}</p>)
            },
            {
                Header: "Income Free",
                accessor: "incomeFree",
                style: { textAlign: 'right', whiteSpace: "pre-line" },
                filterable: false,
                Cell: row => (<div><span style={{ textAlign: 'right' }}>{(row.original.incomeFree)}</span>
                </div>)
            },
            {
                Header: "Income Red.",
                accessor: "incomeRed",
                style: { textAlign: 'right' },
                filterable: false,
                Cell: row => (<span style={{ textAlign: 'right' }}>{(row.original.incomeRed)}</span>)
            },
            {
                Header: "Income Paid",
                accessor: "incomePaid",
                style: { textAlign: 'right' },
                filterable: false,
                Cell: row => (<span style={{ textAlign: 'right' }}>{(row.original.incomePaid)}</span>)
            }]
        ];
        if (tempStatusEligible) {
            cols = [...cols, ...[{
                Header: "Temp Free",
                accessor: "tempFree",
                style: { textAlign: 'right' },
                filterable: false,
                Cell: row => (<span style={{ textAlign: 'right' }}>{(row.original.tempFree)}</span>)
            },
            {
                Header: "Temp Red.",
                accessor: "tempRed",
                style: { textAlign: 'right', whiteSpace: "pre-line" },
                filterable: false,
                Cell: row => (<div><span style={{ textAlign: 'right' }}>{(row.original.tempRed)}</span>
                </div>)
            }]
            ];
        }

        cols = [...cols, ...[
            /*  {
                 Header: "NJEIE",
                 accessor: "njeie",
                 style: { textAlign: 'right', whiteSpace: "pre-line" },
                 filterable: false,
                 Cell: row => (<div><span style={{ textAlign: 'right' }}>{(row.original.njeie)}</span>
                 </div>)
 
             }, */
            {
                Header: "State Free",
                accessor: "stateFree",
                style: { textAlign: 'right', whiteSpace: "pre-line" },
                filterable: false,
                Cell: row => (<div><span style={{ textAlign: 'right' }}>{(row.original.stateFree)}</span>
                </div>)
            },
            {
                Header: "State Reduced",
                accessor: "stateReduced",
                style: { textAlign: 'right', whiteSpace: "pre-line" },
                filterable: false,
                Cell: row => (<div><span style={{ textAlign: 'right' }}>{(row.original.stateReduced)}</span>
                </div>)
            },
            {
                Header: "SNAP",
                accessor: "snap",
                style: { textAlign: 'right' },
                filterable: false,
                Cell: row => (<span style={{ textAlign: 'right' }}>{(row.original.snap)}</span>)
            },
            {
                Header: "TANF",
                accessor: "tanf",
                style: { textAlign: 'right' },
                filterable: false,
                Cell: row => (<span style={{ textAlign: 'right' }}>{(row.original.tanf)}</span>)
            },
            {
                Header: "Foster Child",
                accessor: "fosterChild",
                style: { textAlign: 'right' },
                filterable: false,
                Cell: row => (<span style={{ textAlign: 'right' }}>{(row.original.fosterChild)}</span>)
            },
            {
                Header: "Inst",
                accessor: "inst",
                style: { textAlign: 'right' },
                filterable: false,
                Cell: row => (<span style={{ textAlign: 'right' }}>{(row.original.inst)}</span>)
            },
            {
                Header: "FDPIR",
                accessor: "fdpir",
                style: { textAlign: 'right' },
                filterable: false,
                Cell: row => (<span style={{ textAlign: 'right' }}>{(row.original.fdpir)}</span>)
            },
            {
                Header: "Hd/Ev Start",
                accessor: "hdStart",
                style: { textAlign: 'right', whiteSpace: "pre-line" },
                filterable: false,
                Cell: row => (<div><span style={{ textAlign: 'right' }}>{(row.original.hdStart)}</span>
                </div>)
            },
            {
                Header: "Homeless",
                accessor: "homeless",
                style: { textAlign: 'right' },
                filterable: false,
                Cell: row => (<span style={{ textAlign: 'right' }}>{(row.original.homeless)}</span>)
            },
            {
                Header: "Migrant",
                accessor: "migrant",
                style: { textAlign: 'right' },
                filterable: false,
                Cell: row => (<span style={{ textAlign: 'right' }}>{(row.original.migrant)}</span>)
            },
            {
                Header: "Runaway",
                accessor: "runway",
                style: { textAlign: 'right' },
                filterable: false,
                Cell: row => (<span style={{ textAlign: 'right' }}>{(row.original.runway)}</span>)
            },
            {
                Header: "Medicaid Free",
                accessor: "medicaidFree",
                style: { textAlign: 'right', whiteSpace: "pre-line" },
                filterable: false,
                Cell: row => (<div><span style={{ textAlign: 'right' }}>{(row.original.medicaidFree)}</span>
                </div>)
            },
            {
                Header: "Medicaid Reduced",
                accessor: "medicaidRed",
                style: { textAlign: 'right' },
                filterable: false,
                Cell: row => (<span style={{ textAlign: 'right' }}>{(row.original.medicaidRed)}</span>)
            }, {
                Header: "Direct Cert",
                accessor: "directCert",
                style: { textAlign: 'right' },
                filterable: false,
                Cell: row => (<span style={{ textAlign: 'right' }}>{(row.original.directCert)}</span>)
            }, {
                Header: "Custom Case",
                accessor: "customCase",
                style: { textAlign: 'right' },
                filterable: false,
                Cell: row => (<span style={{ textAlign: 'right' }}>{(row.original.customCase)}</span>)
            }
        ]];
        return cols;
    }

    getStatusColumns = () => {
        const columns = [
            {
                Header: "Status",
                filterable: false,
                accessor: "status",
                style: { textAlign: 'center' },
                // Cell: row => (<span>Total</span>),
            },
            {
                Header: "Total",
                filterable: false,
                accessor: "total",
                style: { textAlign: 'center' },
                filterable: false,
            },
        ]
        return columns;
    }

    getCatogoryColumns = () => {
        const columns = [
            {
                Header: "Category",
                accessor: "category",
                style: { textAlign: 'center' },
                filterable: false,
            },
            {
                Header: "Free",
                accessor: "free",
                style: { textAlign: 'center' },
                filterable: false,
            },
            {
                Header: "Reduced",
                accessor: "reduced",
                style: { textAlign: 'center' },
                filterable: false,
            },
            {
                Header: "Error Prone",
                accessor: "errorProne",
                style: { textAlign: 'center' },
                filterable: false,
            },
            {
                Header: "Regular",
                accessor: "regular",
                style: { textAlign: 'center' },
                filterable: false,
            },
        ]
        return columns;
    }

    buildDataFormatForExport = () => {
        return (
            [{
                columns: this.getEligibilitySummaryColumns().map(col => {
                    return { title: col.Header }
                }),
                data: this.state.summaryDataExport.map(item => {
                    return this.getEligibilitySummaryColumns().map(col => {
                        return { value: item[col.accessor] || '' }
                    })
                })
            }]
        )
    }
    buildDataFormatForApplicationExport = () => {
        const expData = [];
        const gradeGroup = groupBy(getSchoolGrades(0, false), 'value');
        this.state.applicationsExport.map(app => {
            if ((app.eligibility || []).length > 0) {

                (app.eligibility || []).map(ele => {
                    const name = Object.keys(ele)[0] || '';
                    const nameArray = name.split(', ');
                    const eligibility = ele[name] || ''

                    let student = (app.householdAppInfo || []).find(rec =>
                        rec.personType === 'Student' &&
                        rec.fname === (nameArray[1] || '') &&
                        rec.lname === (nameArray[0] || '')
                    );
                    let grade = ((student || {}).grade || '');
                    let gradeName = ((gradeGroup[grade] || [])[0] || {}).label || '';
                    let decisionReason = (student && student.decisionReason) || '';

                    expData.push({
                        applicationId: (("00000" + app.applicationId).slice(-5)),
                        studentName: name,
                        grade: gradeName,
                        date: (moment(app.date, 'MMDDYYYY').format(date_format())),
                        statusUpdateDate: (app.statusUpdateDate ? moment(new Date(app.statusUpdateDate)).format(date_format()) : ''),
                        eligibilityStatus: eligibility,
                        decisionReason: decisionReason,
                        applicationStatus: app.status
                    })
                })
            } else {
                (app.householdAppInfo || []).filter(rec => rec.personType == 'Student').map(record => {
                    const sname = `${record.lname}, ${record.fname}`;
                    let grade = ((record || {}).grade || '')
                    let gradeName = ((gradeGroup[grade] || [])[0] || {}).label || ''
                    expData.push({
                        applicationId: (("00000" + app.applicationId).slice(-5)),
                        studentName: sname,
                        grade: gradeName,
                        date: (moment(app.date, 'MMDDYYYY').format(date_format())),
                        statusUpdateDate: (app.statusUpdateDate ? moment(new Date(app.statusUpdateDate)).format(date_format()) : ''),
                        eligibilityStatus: '',
                        decisionReason: record.decisionReason || '',
                        applicationStatus: app.status
                    })
                })
            }
        })
        return (
            <ExcelFile filename="eligibilityApplicationsExcel" element={<button id="eligibilityApplicationsExcel" className="btn btn-warning btn-xs pull-right" style={{ margin: '0px' }}>
                <i className="fa fa-file-excel-o"></i> Export</button>}>
                <ExcelSheet data={expData} name="Eligibility Applications">
                    <ExcelColumn label={'App.Id'} value={'applicationId'} />
                    <ExcelColumn label={'Student Name'} value={'studentName'} />
                    <ExcelColumn label={'Grade'} value={'grade'} />
                    <ExcelColumn label={'Applied Date'} value={'date'} />
                    <ExcelColumn label={'Eligibility'} value={'eligibilityStatus'} />
                    <ExcelColumn label={'Eligibility Code'} value={'decisionReason'} />
                    <ExcelColumn label={'App.Status'} value={'applicationStatus'} />
                    <ExcelColumn label={'Verified Date'} value={'statusUpdateDate'} />
                </ExcelSheet>
            </ExcelFile>)

    }

  validateContactDetails = () => {
    const { mealSchoolInfo } = this.state;

    if (!mealSchoolInfo) return false;

    const isEmpty = (val) =>
        !val || val === 'NO data found';

    const contactMissing =
        isEmpty(mealSchoolInfo.contactPName) &&
        isEmpty(mealSchoolInfo.contactPEmail) &&
        isEmpty(mealSchoolInfo.contactPPhone);

    const benefitsMissing =
        isEmpty(mealSchoolInfo.benefitsPersonName) &&
        isEmpty(mealSchoolInfo.benefitsPersonEmail) &&
        isEmpty(mealSchoolInfo.benefitsPersonPhone);

    return !(contactMissing && benefitsMissing);
   };

    schoolLunchLetterPrint = (appData) => {
        this.setState({ loading: true });
        get(`/generateHoseholdLetter/${appData.applicationId}?access_token=`)
            .then(async (response) => {
                // ❌ Handle error responses
                if (!response.ok) {
                    const errorRes = await response.json();
                    throw errorRes; // pass full error object
                }

                // ✅ Success → return PDF blob
                return response.blob();
            })
            .then((blob) => {
                print(URL.createObjectURL(blob));
                this.setState({ loading: false });
            })
            .catch((error) => {
                let msg = 'Failed to generate household letter';

                if (error && error.errorMessage) {
                    msg = error.errorMessage;
                } else if (error && error.statusMessage) {
                    msg = error.statusMessage;
                }

                _addNotificationError(msg, this);
                this.setState({ loading: false });
            });
    };

    schoolLunchPrintAllLetters = () => {
        let schoolId = sessionStorage.getItem('SchoolId');
        let schoolYear = sessionStorage.getItem('schoolYearValue');
        this.setState({ loading: true });
        get(`/generateAllHoseholdLetter?schoolId=${schoolId}&schoolYear=${schoolYear}&access_token=`)
            .then(async (response) => {

                // ❌ Handle error responses
                if (!response.ok) {
                    const errorRes = await response.json();
                    throw errorRes; // pass full error object
                }
                // ✅ Success → return ZIP blob
                return response.blob();
            }
            )
            .then((blob) => {
                print(URL.createObjectURL(blob));
                this.setState({ loading: false });
            })
            .catch((error) => {
                let msg = 'Failed to generate household letters';
                if (error && error.errorMessage) {
                    msg = error.errorMessage;
                } else if (error && error.statusMessage) {
                    msg = error.statusMessage;
                }
                _addNotificationError(msg, this);
                this.setState({ loading: false });
            });
    }


    onNewApplicationClick = () => {
        this.context.router.history.push({
            pathname: '/schoolAdmin/newSchoolMealProgram',
            state: {
            }
        });
    }

    onNewApplication_Click = () => {
        this.context.router.history.push({
            pathname: '/schoolAdmin/newSchoolMealProgramApplication',
            state: {
            }
        });
    }


    printAll = () => {
        const data = this.state.newFilterData;
        const { schoolYearSettings } = this.state;
        const { confirmingOfficialUserIds, enableConfirmingOfficial, autoDecisionEligibility } = schoolYearSettings || {};
        let content = '';

        (data || []).map(rec => {
            content = content + buildApplication(rec, enableConfirmingOfficial);
            content = content + '<div style="page-break-after: always;"></div>';

        })
        /*  let printWindow = window.open('', '', 'height=450,width=600');
         printWindow.document.write('<html><head><title>Meal Manage</title>');
         printWindow.document.write('</head><body>');
         printWindow.document.write(
             content
         );
         printWindow.document.write('</body></html>');
         printWindow.document.close();
         printWindow.print(); */



        let frame1 = document.createElement('iframe');
        frame1.name = "frame1";
        frame1.style.position = "absolute";
        frame1.style.top = "-1000000px";
        document.body.appendChild(frame1);
        let frameDoc = frame1.contentWindow ? frame1.contentWindow : frame1.contentDocument.document ? frame1.contentDocument.document : frame1.contentDocument;
        frameDoc.document.open();
        frameDoc.document.write('<html><head><title>Meal Manage</title>');
        frameDoc.document.write('</head><body>');
        frameDoc.document.write(content);
        frameDoc.document.write('</body></html>');
        frameDoc.document.close();
        setTimeout(() => {
            window.frames["frame1"].focus();
            window.frames["frame1"].print();
            document.body.removeChild(frame1);
        }, 500);

    }

    convertBase64 = (file) => {
        return new Promise((resolve, reject) => {
            const fileReader = new FileReader();
            fileReader.readAsDataURL(file)
            fileReader.onload = () => {
                resolve(fileReader.result);
            }
            fileReader.onerror = (error) => {
                reject(error);
            }
        })
    }

    onChangeHandler = async (event, index) => {
        const file = event.target.files[0]
        console.log("File::::", file);
        if (file) {
            //const base64 = await this.convertBase64(file);
            // console.log("base64::::::",base64);
            //selectedFile.attachments = [file];
            // const selectedFile={};
            //selectedFile.fileExt = file.name.split(".")[1];
            //selectedFile.applicationBase64 = base64.split(",")[1];

            this.setState({ selectedFile: file });
            document.getElementById("id" + index).innerHTML = "1 File Selected"
        }

        console.log("selectedFile::::::", this.state.selectedFile);

    };
    uploadApplication = (e, row, index) => {
        const { selectedFile } = this.state;
        //const reqBody = JSON.stringify(selectedFile);
        let formData = new FormData();
        formData.append("letter", selectedFile);
        let headers = {
            "Content-Type": `multipart/form-data`
        };
        post(`/householdApplication/${row.applicationId}/application?access_token=`, formData).then((resp) => {
            if (!resp.ok) {
                throw Error(resp.errorMessage);
            }
            return resp.json();
        }).then(data => {
            if (data.statusCode === 200) {
                _addNotification("File uplaoded successfully", this);
                document.getElementById("id" + index).innerHTML = "Upload File";
                document.getElementById("files" + index).value = null;
                this.setState({ selectedFile: undefined });
                this.getAllApplications();
            }
        }).catch(
            (error) => {
                console.log('Details not saved', error);
                _addNotificationError('Please try again!', this);
            }
        );
    }

    handleSubmit(e, type = '') {

        e.preventDefault();
        // let headers = {
        //      "Content-Type": "multipart/form-data",
        //     "Accept": "application/json"
        // };
        let selectedStdParentEmail = [...new Set(Object.values(this.state.selectionStuList).map(item => item.parentEmail))];
        //let selectedStdGrade = [...new Set(Object.values(this.state.selectionStuList).map(item => item.grade))];
        let user = this.state.loggedUser;
        let data = {
            //"grades": selectedStdGrade,
            "schoolName": user.schoolName,
            "subject": this.state.reqObj.subject,
            "message": this.state.reqObj.htmlText,
            "footer": this.state.reqObj.footer,
            "email": selectedStdParentEmail.join(','),
            //"studentIds": Object.keys(this.state.selectionStuList)
        }
        if (selectedStdParentEmail.length <= 0) {
            _addNotificationError('Parent mail Ids required', this);
            return false;
        }

        if ((this.state.reqObj.subject || '').trim() === '') {
            _addNotificationError('subject is required.', this);
            return false;
        }
        if (this.state.reqObj.htmlText.replace(/<\/?[^>]+(>|$)/g, '').trim() == '' || (this.state.reqObj.htmlText).length === 0) {
            _addNotificationError('message is required.', this);
            return false;
        }
        let headers = {
            "Content-Type": "multipart/form-data",
        };
        let formData = new FormData();
        formData.append('body', JSON.stringify(data));
        (this.state.reqObj.attachments || []).map(file => {
            formData.append('files', file);
        });

        postWithHeaders(`/custom/notification/${this.state.loggedUser.schoolId}/${this.state.loggedUser.schoolYear}?access_token=`, formData, undefined).then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            return response.text();
        }).then(data => {
            const _reqObj = {};
            _reqObj.subject = '';
            _reqObj.message = EditorState.createEmpty();
            _reqObj.htmlText = '';
            _reqObj.attachments = [];
            _reqObj.footer = '';
            this.state.searchStd.searchText = '';
            this.setState({ selectionStuList: {}, selectAll: false, selection: [], tabIndex: 'All' });
            this.setState({ loading: false, reqObj: { ..._reqObj } });
            _addNotification('Email sent Successfully.', this);
            this.setState({ modalIsOpen: false });
            /* setTimeout(() => {
                window.location.reload();
            }, 1000) */
        }).catch(
            (error) => {
                this.setState({ loading: false });
                _addNotificationError('Please try again!', this);
            }
        )
        return false;
    }

    closeModal = (stateObj) => {
        this.setState({ [stateObj]: false });
        const _reqObj = {};
        _reqObj.subject = '';
        _reqObj.message = EditorState.createEmpty();
        _reqObj.htmlText = '';
        _reqObj.footer = '';
        this.state.searchStd.searchText = '';
        this.setState({ selectionStuList: {}, selectAll: false, selection: [], tabIndex: 'All' });
        this.setState({ loading: false, reqObj: { ..._reqObj } });
        this.context.router.history.push('/schoolAdmin/schoolMealProgram');
    }
    handleShow = () => {
        if (Object.keys(this.state.selectionStuList).length == 0) {
            _addNotificationError('please select student.', this);
            return false;
        }
        this.setState({ modalIsOpen: true });
    };
    getNotSubmittedFRMappData = (grade) => {
        let userInfo = JSON.parse(sessionStorage.getItem('loggedInUserInfo'));
        let schoolId = userInfo.schoolId;
        let studentsByGrade = [];
        this.setState({ loading: true })
        get(`/students/notsubmittedFRMapplications?mealSchoolId=${schoolId}&schoolYear=${sessionStorage.getItem('schoolYearValue')}&access_token=`).then((resp) => {
            this.setState({ loading: false });
            if (!resp.ok) {
                throw Error(resp.statusMessage);
            }
            return resp.json();
        }).then(data => {
            const response = data.data;
            const gradesGroup = groupBy(getSchoolGrades(), 'value');
            if ((grade || '0') == '0') {
                return response.map(item => {
                    item.grade = ((gradesGroup[item.grade] || [])[0] || {}).label || '';
                    return {
                        ...item
                    };
                });
            }
            else {
                data.map(item => { //pushes all students for grade selected into an array
                    let _gradeName = item.grade;

                    if (_gradeName === grade) {
                        item.grade = ((gradesGroup[item.grade] || [])[0] || {}).label || '';
                        studentsByGrade.push(item);
                    }
                });
                return studentsByGrade.map(item => {
                    return {
                        ...item
                    };
                });
            }
        }).then(data => {
            this.setState({
                studentsData: data,
                filterStudentsData: data
            });
        }).catch(
            (error) => {
                this.setState({ loading: false });
                console.log('notSubmStudentData', error);
            }
        )
    }

    filterStudentSearch = () => {
        let searchText = this.state.searchStd.searchText;;
        if (searchText.length > 0) {
            let searchedStudent = [];
            let _filterStudentsData = this.state.filterStudentsData;
            _filterStudentsData.forEach(obj => {

                if (obj.parentEmail != null && (obj.parentEmail.toLowerCase()).startsWith(searchText.toLowerCase())) {
                    searchedStudent.push(obj);
                } else if (obj.firstName != null && (obj.firstName.toLowerCase() + ' ' + obj.lastName.toLowerCase()).startsWith(searchText.toLowerCase())) {
                    searchedStudent.push(obj);
                } else if (obj.studentId != null && (obj.studentId.toLowerCase()).startsWith(searchText.toLowerCase())) {
                    searchedStudent.push(obj);
                }
            });
            this.setState({ filterStudentsData: searchedStudent });
        }
        else {
            this.setState({ filterStudentsData: this.state.studentsData });
            //this.getNotSubmittedFRMappData(this.state.tabIndex);
            console.log("this.state.tabIndex ::: ", this.state.tabIndex);
            this.getDataByGrade(this.state.tabIndex);
        }
        this.forceUpdate();
    };
    getDataByGrade(grade) {
        const { studentsData } = this.state;
        if (grade == 'All') {
            this.setState({ filterStudentsData: studentsData });
        } else {
            let _filterStudentsData = studentsData.filter((item, index) => item.grade === grade.toString());
            this.setState({ filterStudentsData: _filterStudentsData });
        }
    }
    removeName = (name, index) => {
        let _selectionStuList = this.state.selectionStuList;

        // Iterate over the object and delete keys with matching parentEmail
        for (let key in _selectionStuList) {
            if (_selectionStuList[key].parentEmail === name) {
                delete _selectionStuList[key];
            }
        }
        this.setState({ selectionStuList: _selectionStuList });
    };

    getColms = () => {
        return [
            {
                Header: 'Student Id',
                accessor: 'studentId',
                width: 200,
                style: { textAlign: 'center' }
            },
            {
                Header: 'Student Name',
                accessor: 'firstName',
                Cell: row => <span>{row.original.firstName + ', ' + row.original.lastName} { }</span>,
                width: 200,
                style: { textAlign: 'center' }
            },
            {
                Header: 'Parent Email Id',
                accessor: 'parentEmail',
                width: 200,
                style: { textAlign: 'left' }
            },
            {
                Header: 'Grade',
                accessor: 'grade',
                width: 200,
                style: { textAlign: 'center' }
            },
        ]
    }

    toggleSelection = (key, shift, row) => {
        //alert('selection')
        // alert(key)
        let selection = [...this.state.selection];
        let selectionStuList = this.state.selectionStuList
        const keyIndex = selection.indexOf(key);
        // check to see if the key exists
        if (keyIndex >= 0) {
            // it does exist so we will remove it using destructing
            selection = [
                ...selection.slice(0, keyIndex),
                ...selection.slice(keyIndex + 1)
            ];
            delete selectionStuList[key];
        } else {
            // it does not exist so add it
            selection.push(key);
            selectionStuList[key] = { studentId: row.studentId, parentEmail: row.parentEmail, grade: row.grade }
            console.log("selectionStuList:::::::::", selectionStuList);
        }
        // update the state
        this.setState({ selectAll: false, selection: selection, selectionStuList: selectionStuList });

        // console.log("selection:", this.state.selection);
    };
    toggleAll = () => {
        //alert('toggleAll')
        const selectAll = this.state.selectAll ? false : true;
        const selection = [];
        let selectionStuList = {}
        if (selectAll) {
            // we need to get at the internals of ReactTable
            const wrappedInstance = this.checkboxTable.getWrappedInstance();
            // the 'sortedData' property contains the currently accessible records based on the filter and sort
            const currentRecords = wrappedInstance.getResolvedState().sortedData;
            //this.setState({studentCount: currentRecords.length});
            // we just push all the IDs onto the selection array
            //console.log(JSON.stringify(currentRecords,null,2))
            currentRecords.forEach(item => {
                selection.push(item._original.studentId);
                selectionStuList[item._original.studentId] = { studentId: item._original.studentId, parentEmail: item._original.parentEmail, grade: item._original.grade }
            });
        }
        this.setState({ selectAll, selection, selectionStuList });
    };
    isSelected = key => {
        const res = (this.state.selection || []).find((item) => {
            const _item = ((item || '') + '').replace('select-', '');
            return _item == key;
        });
        if (res) {
            return true;
        } else {
            return false;
        }
    };

    render() {
        const { toggleSelection, toggleAll, isSelected } = this;
        const { schoolYearSettings } = this.state;
        const { confirmingOfficialUserIds, enableConfirmingOfficial, autoDecisionEligibility, adverseActionProcedure } = schoolYearSettings || {};
        let selectedStdParentEmail = [...new Set(Object.values(this.state.selectionStuList).map(item => item.parentEmail))];
        const { data, selectAll } = this.state;
        gradeList = getSchoolGrades();
        const checkboxProps = {
            selectAll,
            isSelected,
            toggleSelection,
            toggleAll,
            selectType: "checkbox",
            getTheadProps: () => {
                return {
                    style: {
                        backgroundColor: "#D2D7D4", fontWeight: 'bold'
                        // color: selected ? 'white' : 'inherit',
                    },
                    className: "bg-success base-reverse"
                };
            },
            getTableProps: () => {
                return {
                    className: "table table-hover"
                }
            },
        };
        return (<div>
            <NotificationSystem ref="notificationSystem" />
            <div className='sweet-loading' style={{ position: 'fixed', top: '50%', left: '48%', zIndex: '1000   ' }}>
                <BeatLoader
                    size={20}
                    color={'#ea7066'}
                    loading={this.state.loading}
                />
            </div>
            <div className="container">
                <div className="row">
                    <div className="col-md-6 col-sm-12 col-xs-12 sectionTitle">
                        <h2>
                            <span>Eligibility Summary</span>
                        </h2>
                    </div>
                    <div className="col-md-6 sectionTitle text-right">
                        <h2>
                            <TmExportExcel id="eligibilitySummaryExcel"
                                name={"Eligibility Summary"}
                                filename={"EligibilitySummary"}
                                element={<button id="eligibilitySummaryExcel" className="btn btn-warning btn-xs pull-right" style={{ margin: '0px' }}>
                                    <i className="fa fa-file-excel-o"></i> Export</button>}
                                dataSet={this.buildDataFormatForExport()}
                            /></h2>
                    </div>
                </div>
                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12" style={{ marginBottom: '40px' }}>
                    <ReactTable
                        showPaginationBottom={false}
                        columns={this.getEligibilitySummaryColumns()} minRows={this.state.eligibleSummaryData.length} data={this.state.eligibleSummaryData} defaultPageSize={10} className="-striped -highlight" />
                </div>
                <div className="container" style={{ marginBottom: '20px' }}>
                    <div className="row" style={{ display: 'flex' }}>
                        <div className="col-md-6 col-12 ">
                            <div className="row sectionTitle priceTitle" style={{ margin: "-5%" }}>
                                <span><h2>By Status</h2></span>
                            </div>
                            <div style={{ marginLeft: '1%' }}>
                                <ReactTable
                                    showPaginationBottom={false}
                                    columns={this.getStatusColumns()}
                                    data={this.state.statusList}
                                    defaultPageSize={6}
                                    className="-striped -highlight"
                                />
                            </div>
                        </div>
                        <div className="col-md-6 col-12">
                            <div className="row sectionTitle priceTitle" style={{ margin: "-5%" }}>
                                <span><h2>By Category</h2></span>
                            </div>
                            <div style={{ marginLeft: '1%', marginRight: '30px' }}>
                                <ReactTable
                                    showPaginationBottom={false}
                                    columns={this.getCatogoryColumns()}
                                    data={this.state.catagoryList}
                                    defaultPageSize={3}
                                    className="-striped -highlight"
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-6 col-sm-12 col-xs-12 sectionTitle">
                        <h2>
                            <span>School Meal Benefits Program</span>
                        </h2>
                    </div>
                    <div className="col-md-6 sectionTitle text-right">
                        <h2>
                            {/* <TmExportExcel id="eligibilityApplicationsExcel"
                        name={"Eligibility Applications"}
                        filename={"EligibilityApplications"}
                        element={<button id="eligibilityApplicationsExcel" className="btn btn-warning btn-xs pull-right" style={{margin:'0px'}}>
                        <i className="fa fa-file-excel-o"></i> Export</button>}
                        dataSet={this.buildDataFormatForApplicationExport()}
                    /> */}
                            {this.buildDataFormatForApplicationExport()}
                        </h2>
                    </div>
                </div>
                <div className="row" style={{ marginBottom: '10px' }}>
                    <div className="col-md-3">
                        <input type="text" className="form-control" placeholder='Search...' value={this.state.search.searchText} onChange={(e) => {
                            const searchText = e.target ? e.target.value : '';
                            this.setState(prevState => ({
                                search: { ...prevState.search, searchText }
                            }), () => {
                                this.filterData();
                            });
                        }} />
                    </div>
                    <div className="col-md-2">
                        {/* <select className="form-control" value={this.state.search.searchStatus} onChange={(e) => {
                            const _search = { ...this.state.search };
                            _search.searchStatus = e.target.value;
                            this.setState({ search: _search }, () => {

                            })
                        }}>
                            <option>All</option>
                            <option>Verified</option>
                            <option>Pending</option>
                            <option>In-complete</option>
                            <option>Cancelled</option>
                            <option>Denied</option>
                        </select>*/}
                    </div>
                    <div className='col-md-7 text-right'>
                        <button type='button' onClick={this.onNewApplication_Click} className='btn btn-success btn-xs' style={{ margin: '0px', marginRight: '3px' }} >New Application</button>
                        {/* <button type='button' onClick={this.onNewApplicationClick} className='btn btn-success btn-xs' style={{margin:'0px'}} >Add New Application</button>  */}
                        <button className='btn btn-success' onClick={this.printAll}>Print All Applications</button>
                        <button className='btn btn-success'
                            disabled={!this.state.mealSchoolInfo}   // ✅ prevent early click
                            onClick={() => {
                                if (!this.validateContactDetails()) {
                                _addNotificationError(
                                    "School Food Service Director and Fair Hearing Official is required. Go to Profile Details → Account to enter this information.",
                                    this
                                );
                                return;
                                }

                                this.schoolLunchPrintAllLetters();
                            }}
                            >Print All Letters</button>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <div className="table-responsive">
                            <section className="clearfix">
                                <div className="tab-content">
                                    <div className="media">
                                        <div className="panel panel-primary">
                                            <div className="panel-body">
                                                <ReactTable
                                                    data={this.state.newFilterData}
                                                    columns={this.state.columns}
                                                    defaultPageSize={10}
                                                    className="-striped -highlight"
                                                    {...checkboxProps}
                                                    SubComponent={(row) => {
                                                        return (
                                                            <div className="row">
                                                                <div className="col-md-12">
                                                                    <button className="btn btn-xs btn-primary pull-right" onClick={() => {
                                                                        //row.original.editLogs ||
                                                                        this.setState({ editLogModalIsOpen: true, editLogs: [] }, () => {
                                                                            this.getEditLogs(row.original.applicationId);
                                                                        })
                                                                    }}>
                                                                        <i className="fa fa-file-text"></i> Edit logs
                                                                    </button>
                                                                    <button className="btn btn-xs btn-primary pull-right" onClick={() => {
                                                                        schoolLunchAppPrint(row.original, enableConfirmingOfficial);
                                                                    }}><i className="fa fa-print"></i><span>print</span></button>
                                                                    {
                                                                        (row.original.status === 'declined' || row.original.status === 'denied' || row.original.status === 'in-complete' || row.original.status === 'approved') ?
                                                                            <button className="btn btn-xs btn-primary pull-right" onClick={() => {
                                                                                 if (!this.validateContactDetails()) {
                                                                                        _addNotificationError(
                                                                                        "School Food Service Director and Fair Hearing Official is required. Go to Profile Details → Account to enter this information.",
                                                                                        this
                                                                                        );
                                                                                        return;
                                                                                    } 
                                                                                this.schoolLunchLetterPrint(row.original, row.index);
                                                                            }}><i className="fa fa-print"></i><span>print Letter</span></button> : null
                                                                    }
                                                                    <div>

                                                                        {
                                                                            this.state.selectedFile && <Fragment><button className='btn btn-xs btn-danger pull-right' onClick={(e) => {
                                                                                document.getElementById("id" + row.index).innerHTML = "Upload File";
                                                                                document.getElementById("files" + row.index).value = null;
                                                                                this.setState({ selectedFile: undefined });
                                                                            }}>Cancel</button> &nbsp; <button className='btn btn-xs btn-success pull-right' onClick={(e) => {
                                                                                this.uploadApplication(e, row.original, row.index);
                                                                            }}>Save</button></Fragment>
                                                                        }
                                                                        <label for={'files' + row.index} id={'id' + row.index} className="btn btn-xs btn-primary pull-right">Upload File</label>
                                                                        <input type="file" id={'files' + row.index} className="btn btn-xs btn-primary pull-right" accept=".jpg, .jpeg, .png, application/pdf" onChange={e => this.onChangeHandler(e, row.index)} style={{ visibility: "hidden" }} />

                                                                    </div>

                                                                    <div className="row">
                                                                        <div className="col-md-12" id={'app' + row.index}>
                                                                            <SchoolMealProgramView
                                                                                id={row.index}
                                                                                appData={row.original}
                                                                                confirmingOfficialUserIds={confirmingOfficialUserIds || []}
                                                                                enableConfirmingOfficial={enableConfirmingOfficial}
                                                                                autoDecisionEligibility={autoDecisionEligibility}
                                                                                adverseActionProcedure={adverseActionProcedure}
                                                                                loggedUser={this.state.loggedUser}
                                                                                refNotify={this} onSubmitChanges={() => {
                                                                                    this.getAllApplications();
                                                                                }} isAdmin={true} />
                                                                        </div>

                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )
                                                    }}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <Tabs>
                        <div className="col-md-12 col-sm-12 col-xs-12 sectionTitle">
                            <h2>
                                <span>Not Submitted Students</span>
                            </h2>
                        </div>
                        <div className="row col-md-12" style={{ margin: '0' }}>
                            <TabList>
                                {gradeList.map((item) => {
                                    return <Tab onClick={() => {
                                        this.state.tabIndex = item.label;
                                        this.setState({ selectAll: false, tabIndex: item.label })
                                        console.log("this.state.tabIndex ::::: ", this.state.tabIndex);
                                        this.getDataByGrade(this.state.tabIndex);
                                    }}> {item.label}</Tab>
                                }, this)}
                            </TabList>
                        </div>
                        <div className="col-md-3">
                            <input type="text" className="form-control" placeholder='Search...' value={this.state.searchStd.searchText} onChange={(e) => {
                                const searchText = e.target ? e.target.value : '';
                                this.setState(prevState => ({
                                    searchStd: { ...prevState.searchStd, searchText }
                                }), () => {
                                    this.filterStudentSearch();
                                });
                            }} />
                        </div>
                        <div className='col-md-6 sectionTitle text-right' style={{ marginLeft: '25%' }}>
                            <button className="btn btn-sm pull-right btn-danger" style={{ marginTop: '10px' }} type="button" onClick={(e) => {
                                this.handleShow(e)
                            }}>
                                <i className="fa fa-share-square-o" aria-hidden="true"></i> Send Notification
                            </button>
                        </div>
                        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12" style={{ marginBottom: '40px' }}>
                            <CheckboxTable
                                keyField="studentId"
                                expandedRows={true}
                                ref={r => (this.checkboxTable = r)}
                                data={this.state.filterStudentsData}
                                columns={this.getColms()}
                                defaultPageSize={5}
                                className="-striped -highlight"
                                {...checkboxProps}

                            />
                        </div>
                    </Tabs>
                </div>
                <Modal isOpen={this.state.editLogModalIsOpen}
                    onRequestClose={() => this.setState({ editLogModalIsOpen: false, editLogs: [] })}
                    style={modalStyles} contentLabel="Edit Logs" shouldCloseOnOverlayClick={false} ariaHideApp={false}>
                    <div style={{ position: 'relative' }}>
                        <div className='modal-head'>
                            <h4>Application Edit Logs</h4>
                        </div>
                        <div className="modal-body" style={{ maxHeight: '470px', height: '470px', overflowY: 'auto' }}>
                            <EditLog data={this.state.editLogs || []} />


                        </div>
                        <div className='modal-footer' >
                            <div className='row'>
                                <button type="button" className="btn btn-sm btn-primary pull-right" style={{ margin: '0px' }}
                                    onClick={() => this.setState({ editLogModalIsOpen: false })}>Close</button>

                                <button type="button" className="btn btn-sm btn-success pull-right" style={{ margin: '0px 5px 0px 0px' }} onClick={() => {
                                    this.setState({ editLogModalIsOpen: false, editLogs: [] });
                                }}>Ok</button>
                            </div>
                        </div>
                    </div>
                </Modal>
                <Modal
                    isOpen={this.state.modalIsOpen}
                    onRequestClose={() => this.setState({ modalIsOpen: false })}
                    style={modalStyles}
                    contentLabel="Activation"
                    shouldCloseOnOverlayClick={false}
                    ariaHideApp={false}
                >
                    <div className='modal-head'>
                        <h4>Broadcast Message</h4>

                    </div>
                    <div className="modal-body">
                        <div>
                            <div className="form-group" >
                                <label>Subject: </label>
                                <input type='text' className="form-control"
                                    value={this.state.reqObj.subject}
                                    placeholder="subject" spellcheck="false" onChange={(e) => {
                                        this.state.reqObj.subject = e.target.value;
                                        this.setState({ reqObj: { ...this.state.reqObj } });
                                    }} />
                            </div>
                            <div className="form-group">
                                <label>Message: </label>
                                <RichText editorState={this.state.reqObj.message} onEditorStateChange={(editorState) => {
                                    this.state.reqObj.message = editorState;
                                    this.state.reqObj.htmlText = draftToHtml(convertToRaw(this.state.reqObj.message.getCurrentContent()));
                                    this.setState({ reqObj: { ...this.state.reqObj } });
                                }} />
                            </div>
                            <div className='form-group'>
                                <label>Attachments :</label>
                                {
                                    (this.state.reqObj.attachments || []).map((file, i) => {
                                        return <span className="label label-primary">{file.name} <span style={{ cursor: 'pointer' }} onClick={(e) => {
                                            const { reqObj } = this.state;
                                            reqObj.attachments.splice(i, 1);
                                            this.setState({ reqObj: { ...reqObj } });
                                        }}><i className='fa fa-trash'></i></span></span>
                                    })
                                }
                            </div>
                            <div className='form-group'>
                                <input type='file' multiple className='form-control' style={{ marginTop: '-10px' }} onChange={(e) => {
                                    if (e.target.files.length > 0) {
                                        const { reqObj } = this.state;
                                        let files = e.target.files;
                                        //reqObj.attachments = [...reqObj.attachments, ...files];
                                        // Ensure reqObj.attachments is an array
                                        reqObj.attachments = Array.isArray(reqObj.attachments) ? reqObj.attachments : [];

                                        // Append new files to the existing attachments array
                                        reqObj.attachments = [...reqObj.attachments, ...e.target.files];
                                        this.setState({ reqObj: { ...reqObj } });
                                    }
                                    e.target.value = null;
                                }} />
                            </div>
                            <div>
                                <label>Selected parent mail Ids: </label>
                                <div className="panel panel-default">
                                    <div className="panel-body" style={{ minHeight: '200px', overflowY: 'scroll' }}>
                                        <div className='form-group' style={{ display: 'flex', flexWrap: 'wrap' }}>
                                            {selectedStdParentEmail.map((name, index) => (
                                                <div style={{ padding: '3px' }}>
                                                    <span className="badge" style={{ borderRadius: '0px', padding: '5px', fontSize: '14px' }}>{name}
                                                        {/* <span style={{ cursor: 'pointer' }} onClick={(e) => {
                                                        this.removeName(name, index);
                                                    }}><i className='fa fa-trash' role='button' style={{ paddingLeft: '5px' }}></i></span> */}
                                                    </span>


                                                    {/* <input type="text" className="form-control" value={name}
                                    onChange={(e) => this.handleNameEdit(e, index)}
                                     style={{flex: 1,
                                              width:'20%'
                                            }}/>
                              <button 
                                      style={{
                                                position: 'relative',
                                                right: '30px',
                                                background: 'none',
                                                border: 'none',
                                                color: '#888',
                                                cursor: 'pointer',
                                                fontSize: '16px',
                                                pointerEvents: 'auto', 
                                                }}>
                                <i class="fa fa-times" aria-hidden="true"></i>
                              </button> */}
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='modal-footer'>
                        <div className='row'>
                            <div className="col-md-12 text-right">
                                <button type="button" id="cancelAdd" className="btn btn-primary btn-sm"
                                    onClick={() => this.closeModal('modalIsOpen')}
                                    style={{ margin: 0, fontSize: 14, }}>
                                    <i className="glyphicon glyphicon-remove"
                                        style={{ marginRight: 0, paddingLeft: 0 }}></i> Cancel
                                </button>
                                <button type="submit" id="submit" onClick={(e) => { this.handleSubmit(e) }}
                                    className="btn btn-sm btn-success" style={{ margin: 0, marginLeft: '5px', fontSize: 14, }}>
                                    <i className="fa fa-share-square-o"></i><span>Send</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </Modal>
            </div>
        </div>)
    }
}
SchoolLunchProgramList.contextTypes = {
    router: PropTypes.object.isRequired
};
export default SchoolLunchProgramList



// WEBPACK FOOTER //
// ./src/components/SchoolAdmin/SchoolMealProgram/schoolLunchPrgoramList.jsx